export default "__VITE_ASSET__c9b80e8b__"